import { render, staticRenderFns } from "./IdentifierNewItemForm.vue?vue&type=template&id=12f34281&scoped=true"
import script from "./IdentifierNewItemForm.vue?vue&type=script&lang=js"
export * from "./IdentifierNewItemForm.vue?vue&type=script&lang=js"
import style0 from "./IdentifierNewItemForm.vue?vue&type=style&index=0&id=12f34281&prod&scoped=true&lang=css"
import style1 from "./IdentifierNewItemForm.vue?vue&type=style&index=1&id=12f34281&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f34281",
  null
  
)

export default component.exports